import React, { useState, useEffect } from "react";
import { Input } from "@progress/kendo-react-inputs";
import { DatePicker } from "@progress/kendo-react-dateinputs";

import { CustomDropdown } from "../shared/customDropdown";
import { ContestationsResults } from "./contestationsResults";
import { ContestationsMMResults } from "./contestationsMMResults";

import { partnerService } from '../../services/api/partner.service';
import { dropdownService } from '../../services/api/dropdown.service';
import { nomService } from '../../services/api/nom.service';



export const Contestations = () => {

    const partener = sessionStorage.getItem("idPartener");
    const rol = sessionStorage.getItem("rol");

    const [cauta, setCauta] = useState(false);

    const [formValues, setFormValues] = useState({
        partener: (rol == 3) ? partener : 0,
        deladata: "",
        ladata: "",
        cnp: "",
        investigatie: "",
        medic_intern: ""
    });

    const [displayValue, setDisplayValues] = useState({});

    const handleChange = (event) => {
        const { name, value } = event.target;
        if (value && typeof value === "object") {
            if (name == "deladata" || name == "ladata") {
                setFormValues({ ...formValues, [name]: value })
            }
            else {
                setFormValues({ ...formValues, [name]: value.id });
            }
        }
        else {
            setFormValues({ ...formValues, [name]: value })
        }
        
    };

    const handleSearch = () => {
     
        setDisplayValues(formValues);
    }

    return (
        <>
            <h2>Contestatii</h2>
            <div className="formular cautare" data-name="cautare">
                <fieldset>
                    <table className="mb20">
                    <tbody>
                        <tr>
                            <td width="280">
                                    <label className="pb5">Partener</label>
                                    <CustomDropdown
                                        name="partener"
                                        request={dropdownService.getPartners}
                                        requestParams={{ partener: partener }}
                                        onChangeEvent={handleChange}
                                        setFirstValue={true}
                                        className="text ddl-fix" />
                            </td>
                            <td width="280" className="pl10">
                                <label className="pb5">De la data</label>
                                    <DatePicker
                                        className="text"
                                        name="deladata"
                                        onChange={handleChange}
                                    />
                            </td>
                        </tr>
                        <tr>
                            <td width="280">
                                <label className="pt15 pb5">Serviciul</label>
                                    <CustomDropdown
                                        name="investigatie"
                                        request={nomService.getInvestigations}
                                        initialValue={formValues.investigatie}  
                                        onChangeEvent={handleChange}
                                        defaultItem={" "}
                                        className="text ddl-fix" />
                            </td>
                            <td width="280" className="pl10">
                                <label className="pt15 pb5">La data</label>
                                    <DatePicker
                                        name="ladata"
                                        onChange={handleChange}
                                    />
                            </td>
                        </tr>
                        <tr>
                            <td width="280">
                                <label className="pt15 pb5">Medic intern</label>
                                    <CustomDropdown
                                        name="medic_intern"
                                        request={partnerService.getInternalDoctors}
                                        requestParams={{ partener: formValues.partener }}
                                        initialValue={formValues.medic_intern}
                                        dependencies={ [formValues.partener]}
                                        onChangeEvent={handleChange}
                                        className="text ddl-fix"
                                    />
                                
                            </td>
                            <td width="280" className="pl10">
                                <label className="pt15 pb5">CNP</label>
                                    <Input name="cnp" maxLength="13" onChange={handleChange} />
                            </td>
                            </tr>
                        </tbody>
                    </table>

                    <button name="cauta_contestatii" className="btn" onClick={ handleSearch }>Cauta</button>

                </fieldset>
            </div>

            
                
            <div className="pt15" data-name="rezultat_cons">
                <ContestationsResults params={displayValue} />
            </div>

            <div className="pt5" data-name="rezultat_mm">
                <ContestationsMMResults params={displayValue} />
            </div>
                
           
        </>
    );
};



   